import { Box, Center, Flex, Image, Input, Stack } from "@chakra-ui/react";
import CustomText from "./CustomText";

export const TimeBox = ({ text1, text2 }: any) => {
  return (
    <Stack
      w={"100%"}
      h={"64px"}
      borderRadius={"20px"}
      padding={"5px"}
      bg={"#E17F09"}
      justify={"center"}
      align={"center"}
      gap={{ base: "4px", lg: "0px" }}
    >
      <CustomText
        text={text1}
        size={{ base: "24px", xl: "30px" }}
        weight="400"
        color="#FFFAFF"
        height={{ base: "26.44px", xl: "34.14px" }}
      />
      <Box mt={"-10px"}>
        <CustomText
          text={text2}
          size={{ base: "24px", xl: "30px" }}
          weight="400"
          color="#FFFAFF"
          height={{ base: "26.44px", xl: "34.14px" }}
        />
      </Box>
    </Stack>
  );
};

export const CryptoBox = ({ img, name }: any) => {
  return (
    <Center
      borderRadius={"20px"}
      padding={"5px"}
      gap={"5px"}
      flexDir={"row"}
      bg={"#9ADBFF"}
      w={"100%"}
      h={"65px"}
    >
      <Image src={img} alt="crypto-img" />
      <CustomText
        text={name}
        size={{ base: "16px", md: "20px" }}
        height="22.76px"
        color="#191919"
      />
    </Center>
  );
};

export const AmountInput = ({ value, img }: any) => {
  return (
    <Flex
      align={"center"}
      justify={"space-between"}
      borderRadius={"20px"}
      p={"5px 21px 5px 21px"}
      bg={"#9ADBFF"}
      w={"100%"}
      h={"65px"}
    >
      <Input variant={"unstyled"} placeholder="0" value={value} />
      <Image src={img} alt="crypto icon" />
    </Flex>
  );
};

export const KeyValue = ({ text1, text2 }: any) => {
  return (
    <Flex align={"center"} justify={"space-between"} w={"100%"}>
      <CustomText
        text={text1}
        size={{ base: "18px", md: "24px" }}
        height="27.31px"
        color="#191919"
      />
      <CustomText
        text={text2}
        size={{ base: "18px", md: "24px" }}
        height="27.31px"
        color="#191919"
      />
    </Flex>
  );
};
